// UPSCTrainingTabs.jsx
import React, { useState } from "react";
import { Tabs, Tab, Modal, Button, Container, Row, Col } from "react-bootstrap";
import { FaUniversity, FaBook, FaChalkboardTeacher, FaUserGraduate } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

const TrainingTabs = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [key, setKey] = useState("central");

  const handleShow = (item) => {
    setModalData(item);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const trainingData = {
    central: [
      {
        title: "Civil Services & Administrative Sector",
        icon: <FaUniversity size={30} />,
        exams: [
          "Civil Services Exam (IAS, IPS, IRS, IFS)",
          "Indian Forest Service (IFoS)",
          "Engineering Services (ESE)",
          "CDS, NDA, CMS, Geoscientist, ISS, IES",
        ],
        modules: [
          "General Studies, Essay, Ethics",
          "Optional Subjects (History, Geography, Sociology)",
          "Interview Guidance, Mock Tests, Current Affairs",
        ],
      },
      {
        title: "Technical & Engineering Sector",
        icon: <FaBook size={30} />,
        exams: [
          "IES, ISRO, DRDO, BARC, PSU Exams",
          "GATE-based PSU's Recruitments",
          " (BHEL, NTPC, ONGC)",
        ],
        modules: [
          "Core Engineering, Project Management",
          "AI-ML, Robotics, Renewable Energy Systems",
        ],
      },
      {
        title: "Research & Academic Sector",
        icon: <FaChalkboardTeacher size={30} />,
        exams: ["CSIR-NET", "UGC-NET", "ICAR-NET", "ICMR-JRF", "GATE"],
        modules: [
          "Research Methodology, Paper Writing",
          "Proposal Writing, Interview Guidance",
        ],
      },
      {
        title: "Finance, Banking & Economics Sector",
        icon: <FaUserGraduate size={30} />,
        exams: ["RBI, SEBI, NABARD, IBPS, SBI Exams"],
        modules: [
          "Quantitative Aptitude, Reasoning, Banking Awareness",
          "Financial Systems, Economic Policy, Current Affairs",
        ],
      },
    ],
    state: [
      {
        title: "State Administrative & Allied Services",
        icon: <FaUniversity size={30} />,
        exams: [
          "State PSCs: UPPSC, TNPSC, APPSC, MPPSC, KPSC, etc.",
          "Deputy Collector, DSP, Tehsildar, AO",
        ],
        modules: [
          "State GK, History, Polity, Geography, Schemes",
          "Prelims + Mains + Interview Preparation",
        ],
      },
      {
        title: "State Technical & Engineering Services",
        icon: <FaBook size={30} />,
        exams: ["PWD, Irrigation, Transport, Smart City Projects"],
        modules: [
          "Core Subject + State Policy + Environment",
          "Project Management & Quantitative Training",
        ],
      },
      {
        title: "Education & Research Sector",
        icon: <FaChalkboardTeacher size={30} />,
        exams: ["TET, CTET, SET, Assistant Professor, Lecturer"],
        modules: [
          "Pedagogy, Educational Psychology",
          "Subject-Specific Coaching + Teaching Skills",
        ],
      },
      {
        title: "Police, Defence & Safety",
        icon: <FaUserGraduate size={30} />,
        exams: ["SI, Constable, Jailor, Fire Officer"],
        modules: ["Reasoning, GK, Law Basics, Physical & Medical Tests"],
      },
    ],
  };

  return (
    <section className="py-1 bg-light">
      <Container>
         <h1 className="text-center  mb-1 fw-bold text-warning text-uppercase">
              The Brilliance {" "}
              <span className="text-center  mb-1 fw-bold text-success">Behind our Training</span>
            </h1>
        <p className="text-center text-muted mb-1 fw-bold">
          Empowering aspirants with specialized courses for Central & State Government exams across all domains.
        </p>

        <Tabs
          id="training-tabs"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-4 justify-content-center px-3 fw-bold border-2 rounded-2"
        > 
          <Tab eventKey="central"  title="Central Government Exams">
            <Row>
              {trainingData.central.map((item, idx) => (
                <Col md={6} lg={4} key={idx} className="mb-1">
                  <div className="card shadow-sm h-100">
                    <div className="card-body text-center">
                      <div className="mb-3 text-primary">{item.icon}</div>
                      <h3 className="fw-bold text-dark">{item.title}</h3>
                      <ul className="list-unstyled small text-muted mt-2">
                        {item.exams.map((exam, i) => (
                          <li key={i}>• {exam}</li>
                        ))}
                      </ul>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="mt-3"
                        onClick={() => handleShow(item)}
                      >
                        View Details
                      </Button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Tab>

          <Tab eventKey="state" title="State Government Exams">
            <Row>
              {trainingData.state.map((item, idx) => (
                <Col md={6} lg={4} key={idx} className="mb-4">
                  <div className="card shadow-sm h-100">
                    <div className="card-body text-center">
                      <div className="mb-3 text-success">{item.icon}</div>
                      <h5 className="fw-bold">{item.title}</h5>
                      <ul className="list-unstyled small text-muted mt-2">
                        {item.exams.map((exam, i) => (
                          <li key={i}>• {exam}</li>
                        ))}
                      </ul>
                      <Button
                        variant="outline-success"
                        size="sm"
                        className="mt-3"
                        onClick={() => handleShow(item)}
                      >
                        View Details
                      </Button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Tab>
        </Tabs>

        {/* Modal for Details */}
        <Modal show={showModal} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>{modalData.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6 className="fw-bold mb-2">Exam List:</h6>
            <ul className="small text-muted">
              {modalData.exams?.map((exam, i) => (
                <li key={i}>{exam}</li>
              ))}
            </ul>
            <h6 className="fw-bold mt-3">Training Modules:</h6>
            <ul className="small text-muted">
              {modalData.modules?.map((m, i) => (
                <li key={i}>{m}</li>
              ))}
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              href="/enroll"
              className="px-4 fw-semibold"
            >
              Enroll Now
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </section>
  );
};

export default TrainingTabs;
